// Estado in-memory compartilhado do PERFIL da imobiliária (mock).
// Espelha o InMemoryAgencySettingsStore do agency-api: é a fonte única de verdade
// do perfil no modo demo, lida pelo Settings e ESCRITA pelo onboarding — assim os
// dados preenchidos no cadastro aparecem direto em Configurações.

export interface AgencyProfile {
  id: string;
  name: string;
  legalName: string;
  cnpj: string;
  email: string;
  phone: string;
  logoUrl?: string;
  address: {
    street: string;
    number: string;
    neighborhood: string;
    city: string;
    state: string;
    zipCode: string;
  };
  social: {
    instagram?: string;
    facebook?: string;
    website?: string;
  };
}

let current: AgencyProfile = {
  id: "agency_001",
  name: "Imobiliária Horizonte",
  legalName: "Horizonte Gestão Imobiliária LTDA",
  cnpj: "12.345.678/0001-90",
  email: "contato@horizonteimoveis.com.br",
  phone: "(11) 4002-8922",
  logoUrl: "https://placehold.co/200x200/4F46E5/FFF?text=Horizonte",
  address: {
    street: "Avenida das Américas",
    number: "1500",
    neighborhood: "Barra da Tijuca",
    city: "Rio de Janeiro",
    state: "RJ",
    zipCode: "22640-101",
  },
  social: {
    instagram: "horizonte.imoveis",
    website: "www.horizonteimoveis.com.br",
  },
};

export function getAgencyProfileMock(): AgencyProfile {
  return { ...current };
}

/** Merge raso (espelha o PUT /settings/profile). */
export function updateAgencyProfileMock(patch: Partial<AgencyProfile>): AgencyProfile {
  current = { ...current, ...patch, id: current.id };
  return { ...current };
}

/** Substitui o perfil pelos dados do onboarding (preserva id/logo). */
export function setAgencyProfileMock(profile: Omit<AgencyProfile, "id" | "logoUrl">): AgencyProfile {
  current = { ...profile, id: current.id, logoUrl: current.logoUrl };
  return { ...current };
}
